import { useEffect, useState } from "react";
import { fmtTime, loadBasketHistory, shortMint } from "../lib/data";

export default function HistoryPage() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    loadBasketHistory()
      .then((h) => setRows(h.versions))
      .catch((e) => setErr(e.message));
  }, []);

  return (
    <section className="app-section" style={{ paddingTop: "2.5rem" }}>
      <div className="shell readable">
        <p className="section-kicker">
          <i className="brand-diamond" aria-hidden /> History
        </p>
        <h2 className="section-title">Past baskets</h2>
        <p className="section-lead left">
          Every refresh is archived. Entered names join the board; exited names
          leave — prior rewards remain with holders.
        </p>

        {err && <p className="error">{err}</p>}
        {!rows && !err && <p className="loading">Loading archive…</p>}

        {rows && (
          <div className="history-grid">
            {rows.map((b) => (
              <article className="history-card" key={b.version}>
                <div className="history-card__top">
                  <strong>v{b.version}</strong>
                  <span>{fmtTime(b.createdAt)}</span>
                </div>
                <div className="history-syms">
                  {(b.entries || []).map((e) => (
                    <span key={e.mint} title={e.mint}>
                      {e.symbol}
                    </span>
                  ))}
                </div>
                {(b.diff?.entered?.length > 0 || b.diff?.exited?.length > 0) && (
                  <div className="diff-pills">
                    {(b.diff.entered || []).map((m) => (
                      <span className="pill pill--in" key={`i-${m}`}>
                        + {shortMint(m, 3)}
                      </span>
                    ))}
                    {(b.diff.exited || []).map((m) => (
                      <span className="pill" key={`o-${m}`}>
                        − {shortMint(m, 3)}
                      </span>
                    ))}
                  </div>
                )}
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
